import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
    FaHandshake, FaBalanceScale, FaUsers, FaRegSmile, FaRegClock, FaHeart,
    FaFileContract, FaShieldAlt, FaHandsHelping, FaStore, FaUndo, FaDollarSign, FaGift
} from "react-icons/fa";

const principles = [
    { icon: <FaHandshake />, key: "integrity" },
    { icon: <FaBalanceScale />, key: "ethicalSales" },
    { icon: <FaShieldAlt />, key: "honesty" },
    { icon: <FaFileContract />, key: "contractual" },
    { icon: <FaUsers />, key: "fairTreatment" },
    { icon: <FaRegClock />, key: "compensation" },
    { icon: <FaShieldAlt />, key: "antiFraud" },
    { icon: <FaHandsHelping />, key: "mutualConsent" },
    { icon: <FaHeart />, key: "community" },
    { icon: <FaRegSmile />, key: "customerRespect" },
    { icon: <FaStore />, key: "tolerance" },
    { icon: <FaUndo />, key: "cancellation" },
    { icon: <FaDollarSign />, key: "pricing" },
    { icon: <FaGift />, key: "generosity" }
];

export default function BusinessEthics() {
    const { t } = useTranslation('businessEthics');

    return (
        <div className="min-h-screen bg-[#121212] text-[#E0E0E0] flex flex-col items-center p-8">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-blue-500 text-transparent bg-clip-text mb-10">
                {t('businessEthics.title')}
            </h1>
            <div className="w-full max-w-4xl space-y-8">
                {principles.map((principle, index) => (
                    <motion.div
                        key={index}
                        className="p-6 bg-[#1E1E1E] rounded-2xl shadow-lg flex items-center space-x-4"
                        initial={{ opacity: 0, scale: 0.9, y: 50 }}
                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: -50 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: false }}
                    >
                        <motion.div
                            className="text-4xl text-purple-400"
                            initial={{ scale: 0.8, opacity: 0 }}
                            whileInView={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            {principle.icon}
                        </motion.div>
                        <div>
                            <motion.h2
                                className="text-2xl font-bold bg-gradient-to-r from-purple-300 to-blue-400 text-transparent bg-clip-text"
                                initial={{ x: -30, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >
                                {t(`businessEthics.principles.${principle.key}.title`)}
                            </motion.h2>
                            <motion.p
                                className="text-gray-400"
                                initial={{ x: 30, opacity: 0 }}
                                whileInView={{ x: 0, opacity: 1 }}
                                transition={{ duration: 0.5, delay: index * 0.2 }}
                            >
                                {t(`businessEthics.principles.${principle.key}.description`)}
                            </motion.p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}